import { ArrowRight, CalendarDays, HeartHandshake } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';
import { EVENTS } from '../data/siteData';
import { ORGANIZATION_ID, SITE_URL, breadcrumbSchema } from '../lib/seoData';

export default function CommunityEvents() {
  const structuredData = [
    breadcrumbSchema([
      { name: 'Home', path: '/' },
      { name: 'Community Events', path: '/in-the-community' },
    ]),
    {
      '@type': 'CollectionPage',
      '@id': `${SITE_URL}/in-the-community#page`,
      url: `${SITE_URL}/in-the-community`,
      name: 'Halloween & Community Events Richmond BC',
      description: "Jonny's Towing community events, Halloween attractions, fundraisers and family experiences in Richmond, BC.",
      about: { '@id': ORGANIZATION_ID },
      inLanguage: 'en-CA',
    },
  ];

  return (
    <>
      <Seo
        title="Halloween & Community Events Richmond BC"
        description="Explore Jonny's Towing community events, Halloween attractions, fundraisers and family experiences in Richmond, BC."
        image="/images/halloween-truck.webp"
        canonicalPath="/in-the-community"
        structuredData={structuredData}
      />
      <PageHero
        eyebrow="Jonny’s Towing in the community"
        title="We build more than roadside solutions. We build experiences."
        description="Original holiday installations, school programs and community events created to bring people together."
        image="/images/halloween-truck.webp"
      />
      <section className="section container">
        <div className="notice-card" style={{ marginBottom: 30 }}>
          <span className="eyebrow">🎃 School Halloween giving</span>
          <h2>Unwanted vehicles and scrap metal can make a difference.</h2>
          <p>Explore our Halloween community initiative and submit a donation pickup request directly to Jonny’s Towing dispatch.</p>
          <Link className="button button--primary" to="/community/halloween">Discover Halloween Giving <ArrowRight size={18} /></Link>
        </div>
        <div className="timeline">
          {EVENTS.map((event) => (
            <article className="timeline-card" key={event.title}>
              <div className="timeline-year"><CalendarDays /><span>{event.year}</span></div>
              <div>
                <span className="eyebrow">{event.category}</span>
                <h2>{event.title}</h2>
                <p>{event.text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
      <section className="section section--dark">
        <div className="container feature-split">
          <div className="feature-image-wrap"><img src="/images/school-pumpkin-patch.jpg" alt="Jonny's school pumpkin patch installation" /></div>
          <div className="feature-copy">
            <HeartHandshake size={38} />
            <span className="eyebrow">Community comes first</span>
            <h2>Creativity is one of the ways we give back.</h2>
            <p>These projects require design, fabrication, transportation, volunteer hours and cooperation with local organizations. They are part of how Jonny’s Towing contributes to Richmond beyond ordinary roadside work.</p>
            <Link className="button button--secondary" to="/halloween-holiday-trucks">Explore the Halloween &amp; holiday trucks <ArrowRight size={18} /></Link>
          </div>
        </div>
      </section>
    </>
  );
}
